import React from 'react'
import { MrModal } from '@hixme/modal'

// hixme-ui
import Separator from '@hixme-ui/separator'
import Title from '@hixme-ui/title'

// project
import TermsAndConditionsCopy from 'components/TermsAndConditionsCopy'

import classes from './TermsAndConditions.module.scss'

// Match $zIndexModal / $zIndexCartSummary in src/styles/variables/_zIndex.scss
const TERMS_MODAL_OVERLAY_Z_INDEX = 1200
const TERMS_MODAL_CONTENT_Z_INDEX = 1201

const TERMS_MODAL_STYLE = {
  overlay: {
    zIndex: TERMS_MODAL_OVERLAY_Z_INDEX,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflowY: 'auto',
    background: 'rgba(40, 48, 54, 0.8)',
    padding: '16px',
  },
  content: {
    zIndex: TERMS_MODAL_CONTENT_Z_INDEX,
    position: 'relative',
    inset: 'unset',
    top: 'unset',
    right: 'unset',
    bottom: 'unset',
    left: 'unset',
    width: '100%',
    maxWidth: '800px',
    maxHeight: 'calc(100dvh - 32px)',
    margin: '0',
    backgroundColor: '#fff',
    border: '0',
    borderRadius: '6px',
    overflow: 'hidden',
    flexShrink: 0,
  },
}

const TermsAndConditions = () => (
  <MrModal medium contentStart style={TERMS_MODAL_STYLE}>
    <div className={classes.scrollBody}>
      <Title small>Terms &amp; Conditions</Title>
      <Separator light />
      <TermsAndConditionsCopy isModal />
    </div>
  </MrModal>
)

TermsAndConditions.displayName = 'TermsAndConditionsModal'

export default TermsAndConditions
